module.exports = __webpack_public_path__ + "static/media/SWSCRC1-33.b3210d2e.mp3";